
<div class="">
<button class="close-btn general-condition-close" mat-icon-button aria-label="close dialog" mat-dialog-close>
    <mat-icon><div ><img src="/icons/close-light-grey.svg" alt="" width="20" height="20" /></div></mat-icon>
</button>
<mat-dialog-content class="general-condition-content">
<!-- <div> -->
    <div [innerHTML]="webshopContent"></div>
    <!-- <div class="content general-condition">
        <div>
            <h5 style=" text-align: center ; ">Bendix Webshop Terms of Use</h5>
        </div>
        <div>Updated: January 2023<br>The Bendix Webshop (https://b2bendix.com/) is a service provided by Bendix
            Commercial Vehicle Systems LLC (Bendix). The use of the Bendix Webshop, and its features, is subject to the
            following conditions. Registration on the site constitutes your acceptance of these conditions. Please read
            them carefully.</div>
        <div>
            <h5>Electronic Communications</h5>
        </div>
        <div>Use of the Bendix Webshop (https://b2bendix.com/) constitutes your consent to receive communications from
            us electronically, and your acknowledgement that all notices and other communications that we provide to you
            electronically satisfy any business or legal requirement that such communications be 'in writing'.</div>
        <div>
            <h5>Account Information</h5>
        </div>
        <div>If you use the Bendix Webshop, ( https://b2bendix.com/ ) you are responsible for maintaining the
            confidentiality of your account information and password. You agree to accept responsibility for all
            activities that occur under your account. Bendix reserves the right at any time to refuse service, terminate
            accounts, or cancel orders in its sole discretion.</div>
        <div>
            <h5>Warranty Submission</h5>
        </div>
        <div>Claimant understands and agrees that use of the Bendix Webshop warranty system constitutes claimant's
            agreement that Bendix is given the right to audit claims submitted for consideration, and that any
            submission is subject to the terms of the applicable written Bendix product warranty policy (or policies)
            located at ( https://b2bendix.com/ ). </div>
        <div>
            <h5>Software Download</h5>
        </div>
        <div>By installing the new component software, you are about to change the O.E. factory set software parameters
            for a safety-related system. You need to fully understand the implications of making changes to the Bendix
            safety systems by thoroughly reviewing all available information including but not limited to the
            information located at B2Bendix.com so you can make the best-educated decision as it applies to the safe
            operation of your commercial vehicle. </div>
        <div>
            <h5>Terms &amp; Conditions of Sale </h5>
        </div>
        <div>Please refer to the terms and conditions of your Bendix distributorship agreement which shall govern any
            Bendix® products purchased by you via the Bendix Webshop. If a valid and existing distributorship agreement
            is not in place for any reason, then any product sales shall be subject to the Bendix Terms and Conditions
            of Sale located at ( https://b2bendix.com/ ).</div>
        <div>
            <h5>Cross-Reference Information</h5>
        </div>
        <div>Bendix makes every effort to provide accurate information in response to your cross-reference search.
            However, the results do not constitute technical advice. It is the user's sole responsibility to evaluate
            unique operating conditions, compatibility, and application needs and to select the most appropriate
            products.</div><span>Effective Date: March 23, 2020</span><br><span>Last Updated: January 26, 2023</span>
    </div> -->
<!-- </div> -->
</mat-dialog-content>
<mat-dialog-actions>
    <button (click)="accept()" class="mat-raised-button mat-primary mat-accept">{{ 'common.text_button_accept' | cxTranslate }}</button>
</mat-dialog-actions>
